"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Abstraction of Material UI's `Select`
 */
class Select extends _react.default.PureComponent {
  /**
   * Value changed.
   *
   * @param {Event} e
   * @return {void}
   */
  handleChange = e => {
    const id = e.target.value;
    const value = this.props.options.find(o => o.id?.toString() === id)?.value;
    this.props.onChange(value || null, this.props.name);
  };
  /**
   * Render.
   * 
   * @return {ReactNode}
   */

  render() {
    const options = this.options;
    let value = this.props.value;
    if (!value && value !== 0) value = "";else if (this.props.loading || this.props.loadingError || !options.length) value = "";
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_core.TextField, {
      autoComplete: this.props.autoComplete,
      autoFocus: this.props.autoFocus,
      className: this.props.className,
      color: this.props.color,
      disabled: this.props.disabled,
      error: this.props.error,
      fullWidth: this.props.fullWidth,
      helperText: this.props.error && this.props.errorText || this.props.helperText,
      id: this.props.id,
      label: this.props.displayLabel ? this.props.label : undefined,
      name: this.props.name,
      onChange: this.handleChange,
      required: this.props.required,
      select: true,
      SelectProps: this.selectProps,
      size: this.props.size,
      style: this.props.style,
      value: value,
      variant: this.props.variant,
      children: [!this.props.removeLabelOption && /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
        disabled: true,
        value: "",
        children: this.props.label
      }), this.props.loadingError && /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
        disabled: true,
        value: "",
        children: this.props.loadingErrorMessage || "Error."
      }), this.props.loading && /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
        disabled: true,
        value: "",
        children: this.props.loadingMessage || "Loading..."
      }), !options.length && !this.props.loading && !this.props.loadingError && /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
        disabled: true,
        value: "",
        children: this.props.noOptionsMessage || "(No options available)"
      }), options.map((option, key) => /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
        disabled: option.disabled,
        value: option.id,
        children: option.label
      }, key))]
    });
  }
  /**
   * Get available options.
   *
   * @return {Array} Option objects
   */


  get options() {
    return this.props.options.filter(o => !o.hidden);
  }
  /**
   * `SelectProps`
   *
   * @return {Object}
   */


  get selectProps() {
    return {
      multiple: this.props.multiple,
      native: true
    };
  }

  static propTypes = {
    autoComplete: _propTypes.default.string,
    autoFocus: _propTypes.default.bool,
    className: _propTypes.default.string,
    color: _propTypes.default.oneOf(["primary", "secondary"]),
    disabled: _propTypes.default.bool,
    displayLabel: _propTypes.default.bool,
    error: _propTypes.default.bool,
    errorText: _propTypes.default.string,
    fullWidth: _propTypes.default.bool,
    helperText: _propTypes.default.string,
    id: _propTypes.default.string,
    label: _propTypes.default.string,
    loading: _propTypes.default.bool,
    loadingError: _propTypes.default.bool,
    loadingMessage: _propTypes.default.string,
    loadingErrorMessage: _propTypes.default.string,
    multiple: _propTypes.default.bool,
    name: _propTypes.default.string,
    noOptionsMessage: _propTypes.default.string,
    onChange: _propTypes.default.func,
    options: _propTypes.default.array,
    removeLabelOption: _propTypes.default.bool,
    required: _propTypes.default.bool,
    size: _propTypes.default.oneOf(["small", "medium"]),
    style: _propTypes.default.object,
    value: _propTypes.default.any,
    variant: _propTypes.default.oneOf(["standard", "outlined", "filled"])
  };
  static defaultProps = {
    autoFocus: false,
    color: "primary",
    disabled: false,
    displayLabel: false,
    error: false,
    fullWidth: false,
    loading: false,
    loadingError: false,
    multiple: false,
    readOnly: false,
    removeLabelOption: false,
    required: false,
    size: "small",
    variant: "outlined"
  };
}

var _default = Select;
exports.default = _default;